import { TopDestinationsContainer } from './TopDestinationsContainer';

export default TopDestinationsContainer;
